<template>
  <div>
    <Header />
    <div class="statusContent">
      <div class="nav">
        <ul>
          <li :class="{ active: now_tag == 1 }" @click="now_tag = 1">待出貨</li>
          <li :class="{ active: now_tag == 2 }" @click="now_tag = 2">配送中</li>
          <li :class="{ active: now_tag == 3 }" @click="now_tag = 3">已完成</li>
          <li :class="{ active: now_tag == 4 }" @click="now_tag = 4">
            退貨處理中
          </li>
          <li :class="{ active: now_tag == 5 }" @click="now_tag = 5">
            未成立
          </li>
        </ul>
      </div>
      <div class="orders">
        <div
          class="card"
          v-for="order in orders"
          :key="order.order.id"
          v-show="now_tag == order.order.status"
        >
          <router-link
            :to="{ path: '/statusdetail/' + order.order.orderNum }"
            tag="div"
          >
            <h2>下單日期 {{ order.order.orderTime }}</h2>
            <div class="product">
              <img :src="APIURL + 'images/items/' + order.img" alt="" />
              <div class="product_intro">
                <h3>
                  {{ order.names }}
                </h3>
                <h4>x{{ order.amount }}</h4>
                <h5>${{ order.sellPrice * order.amount }}</h5>
              </div>
            </div>
            <div class="total">
              <h4>{{ order.count }} 樣商品</h4>
              <h5>
                訂單金額：<span
                  >${{
                    parseInt(order.order.price, 10) +
                    parseInt(order.order.shipPrice, 10)
                  }}</span
                >
              </h5>
            </div>
          </router-link>
          <div class="status">
            <h4>
              <i class="fas fa-truck"></i>
              <span v-if="order.order.status == 1"> 等待賣家處理</span>
              <span v-if="order.order.status == 2"> 等待賣家出貨</span>
              <span v-if="order.order.status == 3"> 買家取件成功</span>
              <span v-if="order.order.status == 4"> 待退貨處理</span>
              <span v-if="order.order.status == 5"> 未成立訂單</span>
            </h4>
            <div style="display: flex">
              <!-- <button
                v-if="order.order.status == 2"
                @click="openFinish(order.order.orderNum)"
                class="finishBtn"
              >
                完成訂單
              </button> -->
              <button
                v-if="order.order.status ==1"
                @click="openCancel(order.order.orderNum, order.order.status)"
                class="cancelBtn"
              >
                取消訂單
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ConfirmModal" v-if="FinishModalShow">
      <div class="bg" @click="FinishModalShow = false"></div>
      <div class="Modal">
        <h2>確認完成此訂單?</h2>
        <div class="btns">
          <button class="confirm" @click="finishOrder">確認</button>
          <button class="cancel" @click="FinishModalShow = false">取消</button>
        </div>
      </div>
    </div>
    <div class="ConfirmModal" v-if="CancelModalShow">
      <div class="bg" @click="CancelModalShow = false"></div>
      <div class="Modal">
        <h2>確認取消此訂單?</h2>
        <div class="btns">
          <button class="confirm" @click="cancelOrder">確認</button>
          <button class="cancel" @click="CancelModalShow = false">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/header.vue';
import $ from 'jquery';

export default {
  components: {
    Header,
  },
  data() {
    return {
      now_tag: 1,
      phoneNumber: '',
      APIURL: process.env.VUE_APP_APIURL,

      orders: [],

      user_name: '',
      user_avator: '',
      user_id: '',

      FinishModalShow: false,
      FinishData: '',
      CancelModalShow: false,
      CancelData: {
        orderNum: '',
        status: '',
      },
    };
  },

  created() {
    // const vm = this;
    // $.ajax({
    //   url: `${process.env.VUE_APP_APIURL}front/cart/show_order`,
    //   type: 'POST',
    //   data: {
    //     userId: vm.user_id,
    //   },
    //   success(res) {
    //     const data = JSON.parse(res);
    //     console.log('訂單列表', data);
    //     vm.orders = data.result;
    //   },
    // });
    // console.log(this.$route.query.code);
    this.LineLoginValidate();
    // if (vm.user_id) {
    // console.log('有登入');
    // console.log('vm.user_id', vm.user_id);

    // }
  },
  methods: {
    openFinish(orderNum) {
      this.FinishData = orderNum;
      this.FinishModalShow = true;
    },
    openCancel(orderNum, status) {
      this.CancelData.orderNum = orderNum;
      this.CancelData.status = status;
      this.CancelModalShow = true;
    },
    cancelOrder() {
      const vm = this;
      // console.log(vm.user_id);

      vm.$store.commit('setLoading', true);
      $.ajax({
        url: `${process.env.VUE_APP_APIURL}front/cart/reject_order`,
        type: 'POST',
        data: {
          clientId: vm.user_id,
          orderNum: vm.CancelData.orderNum,
          status: vm.CancelData.status,
        },
        success(res) {
          vm.$store.commit('setLoading', false);
          console.log(res);
          if (res === '0') {
            vm.getOrders(vm.user_id);
            vm.CancelModalShow = false;
          }
        },
      });
    },
    finishOrder() {
      // console.log(orderNum);
      const vm = this;

      vm.$store.commit('setLoading', true);
      $.ajax({
        url: `${process.env.VUE_APP_APIURL}front/cart/finish_order`,
        type: 'POST',
        data: {
          userId: vm.user_id,
          orderId: vm.FinishData,
        },
        success(res) {
          // console.log(res);
          vm.$store.commit('setLoading', false);
          if (res === '0') {
            vm.getOrders(vm.user_id);
            vm.FinishModalShow = false;
          }
        },
      });
    },
    LineLoginValidate() {
      console.log('驗證line', this.$route.query.code);
      const vm = this;
      if (this.$cookies.get('access_token')) {
        // alert('有登入過');
        // 驗證如果登入過
        $.ajax({
          url: 'https://api.line.me/v2/profile',
          type: 'GET',
          headers: {
            Authorization: `Bearer ${vm.$cookies.get('access_token')}`,
          },
          success(user) {
            console.log(user);
            if (user.displayName && user.pictureUrl && user.userId) {
              vm.user_name = user.displayName;
              vm.user_avator = user.pictureUrl;
              // vm.user_id = user.userId;
              // 取得資料後傳至後端
              $.ajax({
                url: `${process.env.VUE_APP_APIURL}front/account/line_login`,
                type: 'POST',
                data: {
                  user_name: user.displayName,
                  user_id: user.userId,
                },
                success(ok) {
                  console.log('ok', ok);
                  const oks = JSON.parse(ok);
                  vm.user_id = oks.clientId;
                  vm.getOrders(oks.clientId); // 取得所有訂單
                },
              });
            } else {
              console.log('有登入');
              vm.$cookies.remove('access_token');
              const clientId = process.env.VUE_APP_LINECLIENTID;
              const redirectUri = `${process.env.VUE_APP_URL}status`;
              let link = 'https://access.line.me/oauth2/v2.1/authorize?';
              link += 'response_type=code';
              link += `&client_id=${clientId}`;
              link += `&redirect_uri=${redirectUri}`;
              link += '&state=login';
              link += '&scope=profile%20openid%20email';
              window.location.href = link;
            }
          },
        });
      } else if (this.$route.query.code) {
        // alert('有code');
        // 取得code query
        // console.log(vm.$route.query.code, process.env.VUE_APP_URL);
        $.ajax({
          url: 'https://api.line.me/oauth2/v2.1/token',
          type: 'POST',
          contentType: 'application/x-www-form-urlencoded',
          data: {
            grant_type: 'authorization_code',
            client_id: process.env.VUE_APP_LINECLIENTID,
            client_secret: process.env.VUE_APP_LINESC,
            code: vm.$route.query.code,
            redirect_uri: `${process.env.VUE_APP_URL}status`,
          },
          success(res) {
            console.log(res);
            if (res.access_token) {
              vm.$cookies.set(
                'access_token',
                res.access_token,
                60 * 60 * 24 * 20,
              );
              $.ajax({
                url: 'https://api.line.me/v2/profile',
                type: 'GET',
                headers: {
                  Authorization: `Bearer ${res.access_token}`,
                },
                success(user) {
                  console.log('user', user);
                  vm.user_name = user.displayName;
                  vm.user_avator = user.pictureUrl;
                  // vm.user_id = user.userId;
                  // 取得資料後傳至後端
                  $.ajax({
                    url: `${process.env.VUE_APP_APIURL}front/account/line_login`,
                    type: 'POST',
                    data: {
                      user_name: user.displayName,
                      user_id: user.userId,
                    },
                    success(ok) {
                      console.log('ok', ok);
                      const oks = JSON.parse(ok);
                      vm.user_id = oks.clientId;
                      // vm.user_id = ok.clientId;
                      vm.$router.push('/status');
                      vm.getOrders(oks.clientId); // 取得所有訂單
                    },
                  });
                },
              });
            }
          },
        });
      } else {
        // alert('沒code');
        const clientId = `${process.env.VUE_APP_LINECLIENTID}`;
        const redirectUri = `${process.env.VUE_APP_URL}status`;
        let link = 'https://access.line.me/oauth2/v2.1/authorize?';
        link += 'response_type=code';
        link += `&client_id=${clientId}`;
        link += `&redirect_uri=${redirectUri}`;
        link += '&state=login';
        link += '&scope=profile%20openid%20email';
        window.location.href = link;
      }
      // console.log('this.$route.query.code', this.$route.query.code);
    },
    getOrders(userId) {
      const vm = this;
      console.log('userId', userId);
      vm.$store.commit('setLoading', true);
      $.ajax({
        url: `${process.env.VUE_APP_APIURL}front/cart/show_order`,
        type: 'POST',
        data: {
          userId,
        },
        success(res) {
          console.log('訂單status', res);
          vm.$store.commit('setLoading', false);
          const data = JSON.parse(res);
          console.log('訂單列表', data);
          vm.orders = data.result;
          vm.hasOverSeven = false; // 判斷有無超過七天
          data.result.forEach((item) => {
            if (item.order.status === '2') {
              const date = new Date(item.order.orderTime);
              const timeInMs = Date.now();
              const difference = Math.abs(timeInMs - date);
              console.log(difference / (1000 * 3600 * 24), item.order);

              // 大於七天打完成訂單api
              if (difference / (1000 * 3600 * 24) > 7) {
                console.log('自動完成');
                vm.hasOverSeven = true;
                $.ajax({
                  url: `${process.env.VUE_APP_APIURL}front/cart/finish_order`,
                  type: 'POST',
                  data: {
                    userId: item.order.clientId,
                    orderId: item.order.orderNum,
                  },
                  success(finish) {
                    console.log(finish);
                  },
                });
              }
            }
          });
          if (vm.hasOverSeven === true) {
            vm.getOrders(vm.user_id);
          }
        },
      });
    },
  },
};
</script>

<style>
</style>
